exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upLoadArt{font-size:.6rem}.upLoadArt img{max-width:100%;border:none;vertical-align:middle}", ""]);

// exports
